// test1779
(1779 && 0);
